import React from "react";
import { Paper, Box } from "@mui/material";
import TypewriterText from "./TypewritterText.tsx";
import TypingIndicator from "./TypingIndicator.tsx";

interface MessageBubbleProps {
  text: string;
  sender: "user" | "bot";
  isTyping?: boolean;
  waitingForResponse?: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({
  text,
  sender,
  isTyping = false,
  waitingForResponse = false,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: sender === "user" ? "flex-end" : "flex-start",
        width: "100%",
        mb: 2,
      }}
    >
      <Paper
        elevation={1}
        sx={{
          p: 2,
          borderRadius: 2,
          maxWidth: "95%",
          bgcolor: sender === "user" ? "#fffefeff" : "white",
          color: sender === "user" ? "black" : "black",
          border: sender === "bot" ? "1px solid #e0e0e0" : "1px solid #FD7545",
          "& ul, & ol": {
            paddingLeft: 2,
            margin: "0.5rem 0",
          },
          "& li": {
            marginBottom: "0.25rem",
          },
        }}
      >
        {sender === "user" ? (
          text
        ) : waitingForResponse ? (
          <TypingIndicator color="#FD7545" />
        ) : (
          <TypewriterText text={text} isTyping={isTyping} speed={20} />
        )}
      </Paper>
    </Box>
  );
};

export default MessageBubble;
